import { useEffect, useState } from "react";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, formatRp } from "@/lib/api";
import { assetUrl } from "@/lib/settings";
import { Store, MapPin, Search, Package, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import CityAutocomplete from "@/components/CityAutocomplete";

export default function Marketplace() {
  const [products, setProducts] = useState([]);
  const [city, setCity] = useState("");
  const [category, setCategory] = useState("");
  const [loading, setLoading] = useState(false);
  const [autoCity, setAutoCity] = useState(false);

  const load = async (params = {}) => {
    setLoading(true);
    try {
      const buyer_phone = localStorage.getItem("ti_partner_phone");
      const q = { ...params };
      if (buyer_phone && !q.city) q.buyer_phone = buyer_phone;
      const r = await api.get("/marketplace/products", { params: q });
      setProducts(r.data.products || []);
      if (r.data.city && !city) { setCity(r.data.city); setAutoCity(true); }
    } catch { toast.error("Gagal memuat produk"); }
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const applyFilter = () => load({ city, category });

  return (
    <div className="tech-grid min-h-[calc(100vh-4rem)] py-8 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="mb-6">
          <div className="pill-cyan mb-2"><Store className="w-3 h-3"/> MARKETPLACE LOKAL</div>
          <h1 className="font-display text-3xl lg:text-4xl font-bold text-white">Belanja dari Seller di Kota Anda</h1>
          <p className="text-slate-400 text-sm mt-2 max-w-2xl">Hanya seller yang berada di kota yang sama dengan Anda yang tampil, jadi ongkir lebih murah dan barang cepat sampai.</p>
          {autoCity && city && (
            <div className="mt-3 inline-flex items-center gap-2 text-xs bg-emerald-500/10 border border-emerald-500/30 rounded-full px-3 py-1 text-emerald-300 font-mono-metric">
              <MapPin className="w-3 h-3"/> Lokasi terdeteksi: {city}
            </div>
          )}
        </div>

        <Card className="glass glow-border bg-transparent rounded-2xl p-4 mb-6">
          <div className="grid sm:grid-cols-3 gap-3">
            <CityAutocomplete testid="mp-city" value={city} onChange={setCity} placeholder="Pilih atau ketik kota…"/>
            <Input data-testid="mp-category" placeholder="Kategori (Sembako, Sayur…)" value={category} onChange={e=>setCategory(e.target.value)} className="bg-slate-900/60 border-slate-700 text-white h-11"/>
            <Button data-testid="mp-filter" onClick={applyFilter} disabled={loading} className="bg-cyan-400 hover:bg-cyan-300 text-slate-950 font-bold h-11"><Search className="w-4 h-4 mr-1"/>Cari</Button>
          </div>
        </Card>

        {products.length === 0 ? (
          <div className="text-center py-16">
            <Store className="w-14 h-14 text-slate-700 mx-auto mb-4"/>
            <div className="text-slate-400">Belum ada seller di kota {city || "Anda"}. Coba pilih kota lain atau <a className="text-cyan-300 hover:text-cyan-200 underline" href="/seller/register">daftar jadi seller</a>.</div>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {products.map((p, i) => (
              <div key={i} data-testid={`mp-prod-${i}`} className="bg-slate-900/40 border border-slate-800 rounded-xl overflow-hidden glow-border">
                <div className="h-40 bg-slate-950 flex items-center justify-center">
                  {p.image_url ? <img src={assetUrl(p.image_url)} alt={p.name} className="max-h-full max-w-full object-contain"/> : <Package className="w-10 h-10 text-slate-700"/>}
                </div>
                <div className="p-4">
                  <div className="font-semibold text-white truncate">{p.name}</div>
                  <div className="text-xs text-slate-500 truncate">{p.description}</div>
                  <div className="mt-2 font-mono-metric text-cyan-300 font-bold">{formatRp(p.price)}<span className="text-xs text-slate-500">/{p.unit}</span></div>
                  <div className="mt-2 flex items-center gap-1 text-[10px] text-slate-400">
                    <Store className="w-3 h-3"/>{p.shop_name} · <MapPin className="w-3 h-3"/>{p.city}
                  </div>
                  <a data-testid={`mp-buy-${i}`} href={`https://wa.me/6285147888865?text=${encodeURIComponent(`Halo TokoInduk, saya mau pesan ${p.name} dari ${p.shop_name}`)}`} target="_blank" rel="noreferrer" className="mt-3 flex items-center justify-center gap-1 w-full py-2 rounded-md bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-bold text-xs">
                    <MessageCircle className="w-3 h-3"/>Pesan via WA
                  </a>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
